export default __webpack_public_path__ + "static/O0096-c5749157706658a0fdf0843b85e0510a.png";